/**
 * @description 客戶服務 QA 用
*/
export enum QAClass {
    /** 查詢 e 化保單 */
    EPOLICY = 'EPOLICY',
    /** 查詢快速理賠 */
    QUICKCLAIM = 'QUICKCLAIM'
}
